// extracted by mini-css-extract-plugin
export default {"form":"CreatePassword_form__3r9kd","wrapper":"CreatePassword_wrapper__0NopF","link":"CreatePassword_link__tJTnb","button":"CreatePassword_button__2GSli"};